/* ----------------------------------------------------------------
   Kushface - Shared image lightbox
   One global instance, lazily built, appended to <body>. Exposes
   window.kfLightbox { open(src, alt), close() }. Also opens for any
   click on a [data-lightbox-src] element (value = image URL;
   optional [data-lightbox-alt]). Backdrop / X / Esc close; clicking
   the image keeps it open. Body scroll is locked while open; focus
   moves to the close button and is restored on close. Layered just
   under the cart drawer. No deps.
   ---------------------------------------------------------------- */
(function () {
  "use strict";

  var instance = null;

  function build() {
    if (instance) return instance;

    var el = document.createElement("div");
    el.className = "kf-lightbox";
    el.setAttribute("role", "dialog");
    el.setAttribute("aria-modal", "true");
    el.setAttribute("aria-hidden", "true");

    var close = document.createElement("button");
    close.type = "button";
    close.className = "kf-lightbox__close";
    close.setAttribute("aria-label", "Close image");
    close.innerHTML =
      '<svg viewBox="0 0 20 20" width="20" height="20" fill="none" aria-hidden="true">' +
      '<path d="M4 4l12 12M16 4L4 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="square"/></svg>';

    var img = document.createElement("img");
    img.className = "kf-lightbox__img";
    img.alt = "";
    img.setAttribute("draggable", "false");

    el.appendChild(close);
    el.appendChild(img);
    document.body.appendChild(el);

    var lastFocused = null;

    function open(src, alt) {
      if (!src) return;
      img.src = src;
      img.alt = alt || "";
      el.setAttribute("aria-label", alt || "Image");
      lastFocused = document.activeElement;
      el.classList.add("is-open");
      el.setAttribute("aria-hidden", "false");
      document.documentElement.style.overflow = "hidden";
      close.focus();
    }
    function hide() {
      el.classList.remove("is-open");
      el.setAttribute("aria-hidden", "true");
      document.documentElement.style.overflow = "";
      img.removeAttribute("src");
      if (lastFocused && typeof lastFocused.focus === "function") {
        lastFocused.focus();
      }
    }

    el.addEventListener("click", function (e) {
      if (e.target === img) return; // clicking the image keeps it open
      hide();
    });
    document.addEventListener("keydown", function (e) {
      if (!el.classList.contains("is-open")) return;
      if (e.key === "Escape") { hide(); return; }
      if (e.key === "Tab") { e.preventDefault(); close.focus(); }
    });

    instance = { open: open, close: hide };
    return instance;
  }

  window.kfLightbox = {
    open: function (src, alt) { build().open(src, alt); },
    close: function () { build().close(); }
  };

  // Delegated trigger: any [data-lightbox-src] click opens the lightbox.
  document.addEventListener("click", function (e) {
    var t = e.target.closest ? e.target.closest("[data-lightbox-src]") : null;
    if (!t) return;
    e.preventDefault();
    window.kfLightbox.open(
      t.getAttribute("data-lightbox-src"),
      t.getAttribute("data-lightbox-alt") || ""
    );
  });
})();
